const MS_PER_MINUTE = 60 * 1_000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

export const DEFAULT_WINDOW_END_MS = 90 * MS_PER_DAY;

export function formatWindowMs(ms: number): { value: number; unit: string } {
  if (ms % MS_PER_DAY === 0) {
    const value = ms / MS_PER_DAY;
    return { value, unit: value === 1 ? 'day' : 'days' };
  }
  if (ms % MS_PER_HOUR === 0) {
    const value = ms / MS_PER_HOUR;
    return { value, unit: value === 1 ? 'hour' : 'hours' };
  }
  const value = ms / MS_PER_MINUTE;
  return { value, unit: value === 1 ? 'minute' : 'minutes' };
}

interface MetricMeasurementWindowProps {
  windowStartOffset?: number;
  windowEndOffset?: number;
}

export function MetricMeasurementWindow({ windowStartOffset, windowEndOffset }: MetricMeasurementWindowProps) {
  const isDefault = windowStartOffset === undefined && windowEndOffset === undefined;
  const endMs = windowEndOffset ?? DEFAULT_WINDOW_END_MS;
  const end = formatWindowMs(endMs);

  const hasStart = windowStartOffset !== undefined && windowStartOffset !== 0;

  if (!hasStart) {
    return (
      <span>
        Ends <strong>{end.value}</strong> {end.unit} after exposure{isDefault ? ' (default)' : ''}
      </span>
    );
  }

  if (windowEndOffset !== undefined) {
    const start = formatWindowMs(windowStartOffset as number);
    return (
      <span>
        Start <strong>{start.value}</strong> {start.unit} – End <strong>{end.value}</strong> {end.unit} after exposure
      </span>
    );
  }

  return null;
}
